import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Container, ContainerButtonsCell, HeaderCell, HeaderRow, MachineCell, MachineRow, Table } from './style'
import { columnsMachines, fieldsMachines } from '../utils'
import trash from '../../../../assets/productions/trash.svg'
import search from '../../../../assets/productions/search-in.svg'
import pen from '../../../../assets/productions/pen.svg'
import qr_code from '../../../../assets/productions/qr_code.svg'
import ModalContext from '../../../../contexts/ModalContext'
import axios from '../../../../config/axios'
import { MachineContext } from '../../../../contexts/MachineContext'
import { QRCodeContext } from '../../../../contexts/QRCodeContext'
import ModalTest from '../../../../components/BaseModal'
import CreateMachineModal from '../../../../components/Machines/CreateMachineModal'
import { ButtonCreate, LeftSide, RightSide, SectionName, SubHeaderContainer } from '../../../../components/styles/subheader-style'
import production from '../../../../assets/productions/production.svg'

const MachinesSubHeader:React.FC = () => {
  const { setModalSection, setModalActive } = useContext(ModalContext)
  
  const handleCreateMachine = () => {
    setModalSection('createMachine')
    setModalActive(true)
  }

  return(
    <SubHeaderContainer>
      <LeftSide>
        <SectionName>Máquinas</SectionName>
      </LeftSide>
      <RightSide>
        <ButtonCreate onClick={handleCreateMachine}>+ Criar máquina</ButtonCreate>
      </RightSide>
    </SubHeaderContainer>
  )
}

import { useOutletContext } from 'react-router-dom'

const MachinesTable:React.FC = () => {
  const { setModalSection, setModalActive, modalActive, modalSection } = useContext(ModalContext)
  const { setMachine } = useContext(MachineContext)
  const { setContentJson } = useContext(QRCodeContext)
  const [machines, setMachines] = useState<any[]>([])
  const [refresh, setRefresh] = useState<boolean>(false)
  const context = useOutletContext<any>()
  const searchFilter = context?.search || ''

  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
  
    return `${day}/${month}/${year}`
  }
  
  const handleClickModal = (section:string, position:number) => {
    setMachine(filteredMachines[position])
    setModalActive(true)
    setModalSection(section)
  }

  const handleDelete = async(id:number) => {
    await axios.delete(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/machine/${id}`)
    setRefresh(!refresh)
  }

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/machine`)
    .then((res) => {
      setMachines(res.data)
    }).catch((err) => {
      console.error(err)
    })
  },[refresh])

  const filteredMachines = useMemo(() => {
    if (!searchFilter || !searchFilter.trim()) return machines
    const s = searchFilter.toLowerCase()
    return machines.filter((m: any) =>
      m.name?.toLowerCase().includes(s) ||
      m.model?.toLowerCase().includes(s) ||
      m.serialNumber?.toLowerCase().includes(s) ||
      m.status?.toLowerCase().includes(s)
    )
  }, [machines, searchFilter])

  return(
    <>
      <MachinesSubHeader />
      <Container>
        <Table>
          <tbody>
            <HeaderRow>
              {columnsMachines.map((item, index) => (
                <HeaderCell key={index}>{item}</HeaderCell>
              ))}
            </HeaderRow>
            {filteredMachines.map((item: any, index: number) => (
              <MachineRow key={index}>
                {fieldsMachines.map((field, index) => (
                  <MachineCell key={index}>
                    {field === 'nextMaintenance' || field === 'lastMaintenance' ?
                      <>
                        {formatDate(item[field])}
                      </>
                    : field === 'costPerHour' ?(
                      <>
                        R${item[field].replace('.',',')}
                      </>
                      ): item[field]
                    }
                  </MachineCell>
                ))}
                <MachineCell>
                  <ContainerButtonsCell>
                    <img src={search} onClick={() => handleClickModal('checkMachine', index)} />
                    <img src={qr_code} onClick={() => {
                      setContentJson(JSON.stringify({ machineId: machines[index].id }))
                      handleClickModal('viewQrCode', index)
                    }} />
                    <img src={pen} onClick={() => handleClickModal('editMachine', index)} />
                    <img src={trash} onClick={() => handleDelete(item.id)} />
                  </ContainerButtonsCell>
                </MachineCell>
              </MachineRow>
            ))}
          </tbody>
        </Table>
      </Container>
      {modalActive && (modalSection === 'createMachine' || modalSection === 'editMachine') && (
        <ModalTest>
          <CreateMachineModal />
        </ModalTest>
      )}
    </>
  )
}

export default MachinesTable
